import React     from 'react';
import PropTypes from 'prop-types';

import Modal from '../../components/Modal/Modal';

const DeleteSectionModal = ({ onApprove, onCancel }) => (
  <Modal
    onApprove={onApprove}
    onCancel={onCancel}
  >
    Are you sure? This will delete the section from the SVR.
  </Modal>
);

DeleteSectionModal.propTypes = {
  onApprove : PropTypes.func.isRequired,
  onCancel  : PropTypes.func.isRequired,
};

export default DeleteSectionModal;
